import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Logo from 'assets/images/logo-svg.svg'
import LogoWhite from 'assets/images/logo-white-svg.svg'
import styles from './styles.scss'

const RealhubFooter = ({ dark, link, style }) => (
  <footer className={dark ? classnames(styles.root, styles.dark) : styles.root} style={style}>
    <span className={styles.madeBy}>Built With</span>
    <a href={link}>
      <img alt="Logo" className={styles.logo} src={dark ? LogoWhite : Logo} />
    </a>
  </footer>
)

RealhubFooter.propTypes = {
  dark: PropTypes.bool,
  link: PropTypes.string.isRequired,
  style: PropTypes.object,
}

export default RealhubFooter
